import React, { useState } from 'react';
import { useAccountStore } from '@components/Stores/accountStore';
import { useMaterialsStore } from '@components/Stores/MaterialsStore';
import { DashBoardDonutCard } from '../../components/UI-Elements/DashBoardDonutCard';
import { FutureOrdersSummaryLegend } from '../FutureOrder/FutureOrders/FutureOrdersSummeryGraphs/FutureOrdersSummeryGraphsCharts/FutureOrdersSummaryLegend';
import { IPositionView } from '../../sp-types/financialPositionType';
import {
  aggregatePositions,
  doughnutToMap,
  FinancialMaterialSkeleton,
  getRouteColorsMap,
  positionsRouteColumns,
  positionsToDoughnut,
} from './components/FinancialPositionsUtils';
import { FutureOrdersSummeryBarChart } from '../FutureOrder/FutureOrders/FutureOrdersSummeryGraphs/FutureOrdersSummeryGraphsCharts/FutureOrdersSummeryBarChart';
import { FilterButtons } from './components/FilterButtons';
import BasicTable from './components/BasicTable';
import { Checkbox } from '@mui/material';

interface Props {
  materialId: string;
  positions: IPositionView[];
  showExpired: boolean;
  toggleExpired: () => void;
}
export const FinancialPositionsMaterial: React.FC<Props> = ({ materialId, positions, showExpired, toggleExpired }) => {
  const { materialColorDictionary: colorsMap } = useAccountStore();
  const { materialsMap } = useMaterialsStore();
  const [selectedTable, setSelectedTable] = useState('Route');

  const groupTableBy = [
    { value: 'Route', icon: 'material', disabled: false },
    { value: 'Month', icon: 'calender', disabled: true },
    { value: 'Order', icon: 'orders', disabled: true },
  ];

  return materialId ? (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col bg-white shadow-custom p-3 justify-between max-h-60">
        <h6 className="flex gap-2">
          Routes summary for
          <b style={{ color: colorsMap[materialId] }}>
            {materialsMap[materialId]?.name} ({materialId})
          </b>
        </h6>
        <div className="flex gap-3">
          <div className="w-48 p-3">
            <DashBoardDonutCard
              secondaryTitle="Net value"
              dataSet={positionsToDoughnut(aggregatePositions(positions || [], materialsMap))}
            />
          </div>
          <div className="flex my-auto min-w-[14rem] overflow-y-scroll max-h-[12rem]  ">
            <FutureOrdersSummaryLegend
              materialsDataAsDictionary={doughnutToMap(
                positionsToDoughnut(aggregatePositions(positions || [], materialsMap)),
              )}
              colorsMap={getRouteColorsMap(positions)}
              itemNames={positions.reduce((acc, { routeName: name }) => ({ ...acc, [name]: { name } }), {})}
            />
          </div>
          <div className="flex flex-1 max-h-48 [12rem]">
            <FutureOrdersSummeryBarChart
              materialsDataAsDictionary={aggregatePositions(positions, materialsMap)}
              colorsMap={getRouteColorsMap(positions)}
              itemNames={positions.reduce((acc, { routeName: name }) => ({ ...acc, [name]: { name } }), {})}
            />
          </div>
        </div>
      </div>
      <div className="flex flex-col flex-1 bg-white shadow-custom  justify-between">
        <div className="flex flex-row h-full">
          <FilterButtons {...{ groupTableBy, selectedTable, setSelectedTable }} />
          <div className="flex flex-row flex-1 justify-end me-4">
            <Checkbox className="" onChange={toggleExpired} checked={showExpired} title="Show expired" />
            <label className="justify-center items-center ">Show expired</label>
          </div>
        </div>
        <div className="flex flex-row h-full">
          <BasicTable
            allRows={positions}
            columns={positionsRouteColumns}
            options={{ allowExpand: true, expandDataKey: 'positions', noDataMsg: 'No routes' }}
          />
        </div>
      </div>
    </div>
  ) : (
    <FinancialMaterialSkeleton />
  );
};
